export default __webpack_public_path__ + "static/media/example.0c9ae698.png";